export function readTextFromNDEFRecord(record: NDEFRecord) {
    if (record.recordType === 'text') {
        const textDecoder = new TextDecoder(record.encoding);
        return textDecoder.decode(record.data);
    }
    return undefined;
}

export function isNfcAvailable(): boolean {
    return 'NDEFReader' in window;
}
